class FitGuide extends HTMLElement {
  connectedCallback() {
    const params = new URLSearchParams(window.location.search);
    const handle = (params.get('product') || '').replace(/[^a-z0-9-]/gi, '');
    this.model = this.querySelector('[data-fit-model]');
    this.back = this.querySelector('[data-fit-back]');

    this.back?.addEventListener('click', (event) => {
      // In the product-page popup the X only closes the popup (product-page.js handles it), never goes back.
      if (this.closest('dialog')) return;
      if (!document.referrer) return;
      try {
        if (new URL(document.referrer).origin === window.location.origin && window.history.length > 1) {
          event.preventDefault();
          window.history.back();
        }
      } catch {}
    });

    if (handle && !this.querySelector('[data-fit-size-grid] a')) this.loadProduct(handle);
  }

  async loadProduct(handle) {
    const root = this.dataset.root.endsWith('/') ? this.dataset.root : `${this.dataset.root}/`;
    const url = `${root}products/${handle}`;
    try {
      const response = await fetch(`${url}.js`);
      if (!response.ok) return;
      const product = await response.json();
      if (this.model && !this.model.value) this.model.value = product.title;
      if (this.back) this.back.href = url;
      this.renderSizes(product, url);
    } catch (error) {
      console.warn('[fit-guide] Could not load product', error);
    }
  }

  renderSizes(product, url) {
    const wrap = this.querySelector('[data-fit-sizes]');
    const grid = this.querySelector('[data-fit-size-grid]');
    if (!wrap || !grid || product.variants.length < 2) return;
    const found = product.options.findIndex((option) => /size|größe|velič|méret|velikost/i.test(option.name || option));
    const index = Math.max(found, 0);
    const seen = new Set();
    product.variants.forEach((variant) => {
      const value = variant.options[index];
      if (seen.has(value)) return;
      seen.add(value);
      const link = document.createElement('a');
      link.className = `size-guide__size${variant.available ? '' : ' is-unavailable'}`;
      link.href = `${url}?variant=${variant.id}`;
      link.textContent = String(value).split('-')[0];
      grid.append(link);
    });
    wrap.hidden = seen.size === 0;
  }
}

if (!customElements.get('fit-guide')) customElements.define('fit-guide', FitGuide);
